<div class="account-page-template">
  <div class="breadcrumbs">
    @if (isMobileSmDown()) {
      <a sd-navigation-arrow class="link" [routerLink]="['/my-account/orders']">Все заказы</a>
    } @else {
      <sd-breadcrumbs></sd-breadcrumbs>
    }
  </div>
  <div class="body-content">
    <sd-order-details-items></sd-order-details-items>
  </div>
  <div class="side-content">
    <sd-order-details-shipping></sd-order-details-shipping>
    <sd-order-details-totals></sd-order-details-totals>

    @if (!isTabletDown()) {
      <sd-summary-bonus></sd-summary-bonus>
    }

    <sd-order-repeat-button></sd-order-repeat-button>
    <sd-order-details-actions></sd-order-details-actions>
  </div>
  @if (isTabletDown()) {
    <div class="bottom-content">
      <sd-summary-bonus></sd-summary-bonus>
      <sd-order-repeat-button></sd-order-repeat-button>
      <sd-order-details-actions></sd-order-details-actions>
    </div>
  }
</div>
